import { getViewType } from './InsightsComponentModel.utils';
import ViewType from '../constants/ViewType';

type JobSeekerSuidToFactId = {
    suid: string;
    factId: string;
};

export function getKnownUserSentimentIdMap(jobSeekerSuidsToFactIds: JobSeekerSuidToFactId[]): {
    [key: string]: string[];
} {
    return jobSeekerSuidsToFactIds.reduce(
        (acc: { [key: string]: string[] }, entry: { suid: string; factId: string }) => {
            if (acc[entry.suid]) {
                acc[entry.suid].push(entry.factId);
            } else {
                acc[entry.suid] = [entry.factId];
            }
            return acc;
        },
        {},
    );
}

export const getTrafficLightSignal = (viewType: ViewType): string => {
    if (viewType === ViewType.GREEN) {
        return 'green';
    }
    if (viewType === ViewType.RED) {
        return 'red';
    }
    if (viewType === ViewType.YELLOW) {
        return 'yellow';
    }
    return 'unknown';
};

export function getJobDetailsModel(
    jobSeekerSuidsToFactIds?: platform.model.JobSeekerSuidToFactId[],
    mceModel?: component.oneGraphMatchComparison.OneGraphMatchComparison,
): {
    trafficLightSignal: string;
    knownUserSentimentIdMap: { [key: string]: string[] };
} {
    const trafficLightSignal = getTrafficLightSignal(getViewType(mceModel));

    const knownUserSentimentIdMap = getKnownUserSentimentIdMap(jobSeekerSuidsToFactIds || []);

    return {
        trafficLightSignal,
        knownUserSentimentIdMap,
    };
}
